module.exports = __webpack_public_path__ + "static/media/Finnovex-ME-2025.f7e78b75.png";